import _ from 'lodash';

// Update these to match the internal names of the HubSpot custom behavioral events
// Format: pe{portalId}_{eventInternalName}  (found in HubSpot > Events > Custom Events)
const HS_EVENT_NAME = 'pe48907823_site_search';
const HS_CLICK_EVENT_NAME = 'pe48907823_site_search_result_click';

const DEBOUNCE_MS = 500;
const MIN_QUERY_LENGTH = 2;

function pushToHubSpot(query, resultCount, surface) {
  if (!window._hsq) return;

  window._hsq.push([
    'trackCustomBehavioralEvent',
    {
      name: HS_EVENT_NAME,
      properties: {
        search_query: query,
        search_results_count: resultCount,
        search_is_zero_result: resultCount === 0,
        search_surface: surface,
        page_url: window.location.href
      }
    }
  ]);
}

const debouncedTrack = _.debounce(pushToHubSpot, DEBOUNCE_MS);

/**
 * @param {string} query
 * @param {number} resultCount
 * @param {'search_page'|'site_search'|'header_autosuggest'} surface
 */
export function trackSearch(query, resultCount, surface) {
  if (!query || query.trim().length < MIN_QUERY_LENGTH) return;
  debouncedTrack(query.trim(), resultCount, surface);
}

/**
 * @param {string} query
 * @param {string} resultTitle
 * @param {string} resultUrl
 * @param {number|null} position
 * @param {'search_page'|'site_search'|'suggestion_click'} surface
 */
export function trackSearchResultClick(query, resultTitle, resultUrl, position, surface) {
  if (!window._hsq) return;

  window._hsq.push([
    'trackCustomBehavioralEvent',
    {
      name: HS_CLICK_EVENT_NAME,
      properties: {
        search_query: query,
        result_title: resultTitle,
        result_url: resultUrl,
        result_position: position,
        search_surface: surface,
        page_url: window.location.href
      }
    }
  ]);
}
